export default __webpack_public_path__ + "static/media/PAFI_Audit Report 2025.c1ab9b3f.pdf";